module.exports = __webpack_public_path__ + "img/20220108_154648.4a387fc7.jpg";